import React from 'react';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { MParticleEvent } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { CORE_WEB_ORIGIN } from '@reverbdotcom/env';

interface IProps {
  to: string;
  className?: string;
  clickEvent?: MParticleEvent;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  children: React.ReactNode;
}

export function toCurrentHost(href: string): string {
  return href.startsWith(`${CORE_WEB_ORIGIN}/`) ? href.slice(CORE_WEB_ORIGIN.length) : href;
}

/**
 * Every link that leaves the notifications panel.
 *
 * `target="_self"` is the browser default and reads as redundant, but CoreLink branches on
 * `!!target` to decide whether to skip its own routing. Drop it and these go client-side.
 */
export const NotificationLink = React.forwardRef<HTMLAnchorElement, IProps>(
  ({ to, className, clickEvent, onClick, children }, ref) => (
    <CoreLink
      ref={ref}
      to={toCurrentHost(to)}
      target="_self"
      className={className}
      clickEvent={clickEvent}
      onClick={onClick}
    >
      {children}
    </CoreLink>
  ),
);
NotificationLink.displayName = 'NotificationLink';
